import { apiClient } from "./apiClient";

export const supportApi = {
  list: (params) => apiClient.get("/support/tickets", { params }).then((r) => r.data),
  create: (payload) => apiClient.post("/support/tickets", payload).then((r) => r.data),
  /* THE WRITE PATH app.UserFeedback NEVER HAD (#432). The table has been
     read since V001 -- by the admin sentiment surface and by the GDPR
     export -- and written by nothing, so both were reporting on a table
     nobody could fill. Separate from a ticket on purpose: a ticket is a
     request for help with a status somebody owes you, feedback is an
     opinion that expects no reply. */
  sendFeedback: (payload) => apiClient.post("/feedback", payload).then((r) => r.data),
};
